import { EntityService } from '@/services/EntityService';

export class DocumentsListsService extends EntityService {
  static get entity() {
    return 'documents/list-of-documents';
  }
}
